<template>
  <div>
    <el-table v-loading="loading"  :data="list" style="min-height: 300px" border size="small">
      <el-table-column label="序号" width="100px" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="会议名称" prop="meeting_name"  align="center">

      </el-table-column>
      <el-table-column label="状态" prop="status_msg"  align="center">

      </el-table-column>
      <el-table-column label="创建时间" prop="created_at"  align="center">

      </el-table-column>

      <el-table-column label="操作" style="min-width: 200px"  align="center">
        <template slot-scope="scope">
          <div class="row-view center-view">
            <el-button type="text" @click="onStopClick(scope.row)" v-if="scope.row.status!==1">结束</el-button>
            <el-button type="text" @click="onShowClick(scope.row,scope.$index)">查看</el-button>
          </div>
        </template>
      </el-table-column>
      <template #empty>
        <yc-no-content  des="暂没有相关会议哦~" :show_button="true" button_des="一键生成年度会议"
                       @onButtonClick="onCreateVote"></yc-no-content>
      </template>
    </el-table>

  </div>

</template>

<script>
import YcNoContent from "@/components/commonComponents/yc-no-content";

export default {
  name: "VoteTable",
  components: {YcNoContent},
  data() {
    return {
      loading: false,
      list: [
      ],
    }
  },
  methods: {
    //让当前页面展示loading
    showLoading() {
      this.loading = true;
    },
    //设置当前页面页面数据并取消loading
    setData(list) {
      this.list = list;
      this.loading = false
    },

    onCreateVote() {
      this.$emit('onCreateVote');
    },

    refreshData() {
      this.$emit('refreshData');
    },
    onStopClick(item){
      this.$prompt('当前操作无法撤回,请确认参会人员全部投票完成。是否结束会议？', '结束会议', {
        confirmButtonText: '结束',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '结束中...'
            this.http.api('finishMeeting', { id: item.id }).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '结束'
                done()
                this.$commonUtils.showMessage('操作成功')
                this.refreshData();
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '结束'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '结束'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })


    },
    onShowClick(item,index){
        this.$router.push({path:'/voteManagement/voteDetail',query:{id:item.id,position:index,time:item.created_at}})
    }
  }
}
</script>

<style scoped>

</style>
